module.exports = __webpack_public_path__ + "img/TheBusinessRegister.5fa3cc06.svg";